import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

// modules
import styles from '../Containers.module.scss';

class TermsOfUse extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.TermsOfUse}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/about">
                <BreadcrumbItem active>Terms of Use</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <p>
            The M.L.S. of Naples, Inc. ("Naples MLS"), a wholly owned subsidiary of the
            Naples Area Board of REALTORS<sup>®</sup> and Association of Real Estate
            Professional, Inc. d/b/a the Naples Area Board of REALTORS<sup>®</sup>{' '}
            (hereinafter "NABOR<sup>®</sup>") owns and operates for the benefit of itself
            and NABOR<sup>®</sup> the website at www.naplesarea.com (the "Website"). You
            agree to accept and comply with the terms, conditions, and notices stated
            herein as may be modified by the Naples MLS from time to time without notice
            to you. You are responsible for regularly reviewing the Website and these
            Terms of Use for updates. You expressly acknowledge that you have read and
            understand these Terms of Use and agree to be bound by them. If you do not
            wish to be bound by these Terms of Use, please do not access or use this
            Website.
          </p>

          <p>
            In addition to these Terms of Use, please also review our Privacy Policy for
            information about our commitment to protecting your privacy and our DMCA
            Policy for the display of content posted by users of the Website and the
            Naples MLS’ procedures for responding to Complaints and Counter Notices
            pursuant to the Digital Millennium Copyright Act about allegedly infringing
            content that may be posted to, or linked from, the Website by third parties.
          </p>

          <p>
            The Naples MLS and NABOR<sup>®</sup> offer you access to the data contained on
            this Website solely for your use in identifying property for sale or lease in
            the greater Naples, Florida market, and you agree to access this Website only
            for purposes permitted by this Terms of Use.
          </p>

          <p>
            1. You represent and warrant that you are over the age of majority, legally
            competent to enter into this Agreement. You further warrant that you are using
            the Website to identify properties currently for sale or lease that are
            located in the Naples, Florida area. You understand and acknowledge that the
            Website is owned, operated and maintained by Naples MLS for the benefit of
            NABOR<sup>®</sup>. You further understand and agree that you may be able to
            link from this Website to websites or web pages owned or operated by, or on
            behalf of, parties other than the Naples MLS or NABOR<sup>®</sup>. If you link
            to such other websites or web pages, you understand and agree that any
            products, services, or information available at such other websites or web
            pages, and the terms and conditions under which such products, services, and
            information are being offered, are being provided or determined solely by the
            entities that own or operate such sites or pages, and not by the Naples MLS or
            NABOR<sup>®</sup>. Neither the Naples MLS nor NABOR<sup>®</sup> is responsible
            or liable for the content of any linked website nor the accuracy of any
            information provided therein. The Naples MLS and NABOR<sup>®</sup> do not make
            any representation or warranty with respect to such third party websites and
            is not responsible for their accuracy, sufficiency, veracity, completeness or
            timeliness. You acknowledge that if you access a third party website from this
            Website, you do so at your own risk. You understand that a hyperlink to a
            third party website does not imply that either the Naples MLS or NABOR
            <sup>®</sup> endorses the content on, or the business of, the hyperlinked
            website. You understand that you are solely responsible for determining the
            integrity and reliability of the information on this Website as well as any
            information found on a third party website linked to this Website. You agree
            that neither the Naples MLS nor NABOR<sup>®</sup> shall be responsible for any
            loss or damage of any sort relating to your dealings with such third parties.
            You are responsible for reviewing the applicable terms of use agreements and
            privacy policies of the third party websites.
          </p>

          <p>
            2. When conducting a search for available properties for sale or rent, You
            understand that the Naples MLS has the right to limit the number of properties
            displayed to you in response to your search requests based upon the Naples
            MLS' sole determination of the reasonable number of properties appropriate to
            be displayed in response to a single search request, given existing market
            conditions, technology limitations, total number of matching listings in the
            Naples MLS database compilation, and other "reasonable use" restrictions
            deemed appropriate by the Naples MLS from time to time.
          </p>

          <p>
            You understand and agree that this Website may include information, tips,
            facts, views and opinions about the Southwest Florida or national real estate
            market that the Naples MLS or NABOR<sup>®</sup> deems worthy of publication.
            ALL SUCH MATERIAL IS FOR INFORMATION PURPOSES ONLY AND IS NOT PROFESSIONAL
            ADVICE UPON WHICH YOU OR ANY THIRD PARTY SHOULD RELY IN MAKING ANY DECISION
            CONCERNING THE ACQUISITION OR SALE OF REAL PROPERTY, OR ANY PERSONAL, LEGAL,
            BUSINESS, OR FINANCIAL DECISIONS.
          </p>

          <p>
            3. You agree that, as between the Naples MLS and NABOR<sup>®</sup> on one hand
            and yourself on the other hand, any electronic or printed real estate listing
            data, or other content derived from this Website ("Site Materials"),
            constitute the copyrighted or copyrightable and proprietary property of the
            Naples MLS, NABOR
            <sup>®</sup> or third parties from whom the Naples MLS or NABOR
            <sup>®</sup> has secured permission to display such Site Materials on this
            Website. You acknowledge that the Naples MLS has granted to you a limited,
            revocable, and non-exclusive license to use these Site Materials solely for
            your private use. You will not commercialize, sell, license, re-license,
            sublicense, modify, reverse engineer, swap, or re-purpose the Site Materials,
            nor will you assist others in doing so.
          </p>

          <p>
            4. The Naples MLS reserves the right, without notice and in its sole
            discretion, to terminate your license to use the Website, and to block or
            prevent future access to and use of the Website. The foregoing license grant
            does NOT, without the express written permission of the Naples MLS or NABOR
            <sup>®</sup>, include the right for you to:{' '}
          </p>
          <p>
            a. publish, publicly perform or display, or distribute to any third party any
            Site Materials, including reproduction on any computer network or broadcast or
            publications media; provided, however that you may retransmit without
            financial consideration individual listings contained in the Site Materials to
            relatives, friends, or business associates;{' '}
          </p>
          <p>
            b. market, sell or make commercial use of the Website or any Site Materials;{' '}
          </p>
          <p>
            c. systematically collect and use any data or content including through the
            use of any spiders, robots, or similar data gathering, mining or extraction
            methods;{' '}
          </p>
          <p>d. make derivative uses of the Website or the Site Materials; or </p>
          <p>
            e. use, frame or utilize framing techniques to enclose any portion of this
            Website (including the images found at this Website or any text or the
            layout/design of any page or form contained on a page).{' '}
          </p>

          <p>
            5. You will use your best efforts to cooperate with the Naples MLS or NABOR
            <sup>®</sup> on reasonable terms and conditions in the event Naples MLS or
            NABOR<sup>®</sup> deems it necessary to seek to enjoin or otherwise prohibit
            the unauthorized use of the Site Materials by a third party, which use may
            have resulted from your access to this Website.
          </p>

          <p>
            6. This Website contains proprietary information that that is protected by
            applicable intellectual property and other laws, and you acknowledge and agree
            that the proprietary information is protected by copyrights, trademarks,
            service marks, patents or other proprietary rights and laws. If you believe
            that any content posted to, or linked from, the Website infringes upon your
            copyright rights, please consult the DMCA Policy accessible from this Website
            and follow the procedures set forth in that Policy.
          </p>

          <p>
            7. If any part of the Terms of Use is determined to be invalid or
            unenforceable pursuant to applicable law including, but not limited to, the
            warranty disclaimers and liability limitations contained herein, then the
            invalid or unenforceable provision will be deemed superseded by a valid,
            enforceable provision that most closely matches the intent of the original
            provision and the remainder of the Terms of Use shall continue in effect. This
            Terms of Use constitutes the entire agreement between you on the one hand and
            Naples MLS and NABOR<sup>®</sup> on the other hand with respect to the Website
            and Site Materials and it supersedes all prior or contemporaneous
            communications and proposals, whether electronic, oral or written, between you
            and Naples MLS or NABOR<sup>®</sup> with respect to the Website and Site
            Materials. The failure of Naples MLS or NABOR<sup>®</sup> at any time or times
            to require performance of any provision hereof shall in not in any manner
            affect the right of Naples MLS or NABOR<sup>®</sup> at a later time to enforce
            the same. A printed version of the Terms of Use and of any notice given in
            electronic form shall be admissible in judicial or administrative proceedings
            based upon or relating to the Terms of Use to the same extent and subject to
            the same conditions as other business documents and records originally
            generated and maintained in printed form. You agree that any and all
            communications and dealings between you, Naples MLS or NABOR<sup>®</sup>{' '}
            relating to the Website and this Terms of Use Agreement may be conducted
            through electronic means.{' '}
          </p>

          <p>
            8. ALL CONTENT ON THIS WEBSITE IS PROVIDED "AS IS" AND "AS AVAILABLE" AND
            WITHOUT WARRANTIES OF ANY KIND EITHER EXPRESS OR IMPLIED OR GUARANTIES WITH
            REGARD TO THE APPROPRIATENESS, ACCURACY, SUFFICIENCY, VERACITY, VALUE,
            COMPLETENESS, OR TIMELINESS OF THE WEBSITE CONTENT. NAPLES MLS AND NABOR
            <sup>®</sup> DISCLAIM ANY AND ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING,
            BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
            PARTICULAR PURPOSE AND NON-INFRINGEMENT. NEITHER NAPLES MLS OR NABOR
            <sup>®</sup>, THEIR AFFILIATED OR RELATED ENTITIES, NOR ANY PERSON INVOLVED IN
            THE CREATION, PRODUCTION, AND DISTRIBUTION OF THIS WEBSITE WARRANT THAT THE
            FUNCTIONALITY AVAILABLE ON THIS WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE,
            THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVER THAT MAKES THE CONTENT
            AVAILABLE WILL BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. THE CONTENT
            THAT YOU ACCESS ON THIS WEBSITE IS PROVIDED SOLELY FOR YOUR CONVENIENCE AND
            INFORMATION ONLY. THE NAPLES MLS AND NABOR<sup>®</sup> USE GOOD FAITH EFFORTS
            TO PROVIDE ACCURATE, COMPLETE, AND CURRENT INFORMATION ON THIS WEBSITE, BUT
            YOU UNDERSTAND THAT IT IS YOUR RESPONSIBILITY TO VERIFY ANY INFORMATION
            PROVIDED ON OR THROUGH THIS WEBSITE. NEITHER THE NAPLES MLS NOR NABOR
            <sup>®</sup> WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE RESULTS THAT
            MAY BE OBTAINED FROM THE USE OF THIS WEBSITE, OR AS TO THE RELIABILITY,
            ACCURACY OR CURRENCY OF ANY INFORMATION CONTENT, OR SERVICE PURSUANT TO YOUR
            USE OF THIS WEBSITE. YOU EXPRESSLY AGREE THAT USE OF THIS WEBSITE IS AT YOUR
            SOLE RISK. YOU (AND NOT THENAPLES MLS OR NABOR<sup>®</sup>) ASSUME THE ENTIRE
            COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION OF YOUR SYSTEM. YOU
            EXPRESSLY AGREE THAT NEITHER THE NAPLES MLS, NABOR<sup>®</sup>, NOR THEIR
            AFFILIATED OR RELATED ENTITIES, NOR ANY OF THEIR RESPECTIVE EMPLOYEES, OR
            AGENTS, NOR ANY PERSON OR ENTITY INVOLVED IN THE CREATION, PRODUCTION AND
            DISTRIBUTION OF THIS WEBSITE, IS RESPONSIBLE OR LIABLE TO ANY PERSON OR ENTITY
            WHATSOEVER FOR ANY LOSS, DAMAGE (WHETHER ACTUAL, CONSEQUENTIAL, PUNITIVE OR
            OTHERWISE), INJURY, CLAIM, LIABILITY OR OTHER CAUSE OF ANY KIND OR CHARACTER
            WHATSOEVER BASED UPON OR RESULTING FROM THE USE OR ATTEMPTED USE OF THIS
            WEBSITE OR ANY OTHER LINKED SITE. BY WAY OF EXAMPLE, AND WITHOUT LIMITING THE
            GENERALITY OF THE FOREGOING, THE NAPLES MLS, NABOR<sup>®</sup> AND RELATED
            PERSONS AND ENTITIES SHALL NOT BE RESPONSIBLE OR LIABLE FOR ANY CLAIM OR
            DAMAGE ARISING FROM FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION,
            DELETION, DEFECT, DELAY IN OPERATION, COMPUTER VIRUS, THEFT, DESTRUCTION,
            UNAUTHORIZED ACCESS TO OR ALTERATION OF PERSONAL RECORDS, OR THE RELIANCE UPON
            OR USE OF DATA, INFORMATION, OPINIONS OR OTHER MATERIALS APPEARING ON THIS
            WEBSITE. YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT NEITHER THE NAPLES MLS NOR
            NABOR<sup>®</sup> IS LIABLE OR RESPONSIBLE FOR ANY DEFAMATORY, OFFENSIVE OR
            ILLEGAL CONDUCT OF THIRD PARTIES. SOME JURISDICTIONS MAY NOT ALLOW THE
            EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES.
            IN SUCH JURISDICTIONS, THE NAPLES MLS AND NABOR<sup>®</sup>'S LIABILITY IS
            LIMITED TO THE GREATEST EXTENT PERMITTED BY LAW. IF YOU ARE DISSATISFIED WITH
            ANY PORTION OF THE WEBSITE, OR WITH ANY OF THESE TERMS OF USE, YOUR SOLE AND
            EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE WEBSITE. You agree that the
            Naples MLS may amend or modify these Terms of Use at any time without notice
            to you. Your use of this Website after the Naples MLS has amended or modified
            these Terms of Use shall be deemed your acceptance of such amendments or
            modifications.
          </p>

          <p>
            9. You agree to indemnify, defend, and hold harmless the Naples MLS, NABOR
            <sup>®</sup> and their officers, directors, employees, affiliates, agents,
            licensors, and suppliers from and against all losses, expenses, damages and
            costs, including reasonable attorneys' fees, resulting from any violation by
            you of these Terms of Use.
          </p>

          <p>
            10. You agree that your unauthorized use of the Site Materials will cause
            injury to the Naples MLS or NABOR<sup>®</sup> that cannot adequately be
            remedied by money damages, and that the Naples MLS or NABOR<sup>®</sup> shall
            be entitled to preliminary or permanent injunctive relief to enjoin your
            unauthorized use of the Website or Site Materials, which injunctive relief
            shall be in addition to any other remedies available to such parties at law or
            equity. If the Naples MLS or NABOR<sup>®</sup> is successful in securing a
            preliminary injunction order against you, you waive any obligation of the
            Naples MLS or NABOR<sup>®</sup> to post a security bond in conjunction
            therewith.
          </p>

          <p>
            11. You understand that neither the Naples MLS nor NABOR<sup>®</sup> has
            entered into any form of fiduciary or brokerage relationship with you solely
            by granting you access to, and use of, the Website. Any form of fiduciary or
            brokerage relationship is expressly between you and any licensed real estate
            professional from whom you may choose to obtain brokerage services.
          </p>

          <p>
            12. You agree that this Terms of Use Agreement shall be governed by the laws
            of the State of Florida applicable to contracts made and performed entirely in
            the State of Florida. Any suit brought to interpret or enforce the terms and
            conditions of this Terms of Use Agreement shall be brought in the state or
            federal courts that have jurisdiction over Collier County, Florida. You agree
            not to contest the personal jurisdiction of such courts. If the Naples MLS or
            NABOR
            <sup>®</sup> prevails in any suit against you to interpret or enforce this
            Terms of Use Agreement, you agree that the Court may enter an award on behalf
            of the Naples MLS or NABOR<sup>®</sup> and against you for the Naples MLS' or
            NABOR<sup>®</sup>'s reasonable attorney's fees, costs, and litigation expenses
            associated with such suit, or the appeal of any judgment or award rendered on
            behalf of the Naples MLS or NABOR<sup>®</sup>.{' '}
          </p>
        </Container>
      </Container>
    );
  }
}

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/containers/TermsOfUse/TermsOfUse.js